/** @file Finds the -L/-R counterpart mesh of a mesh attachment by name (format mirrorName). */
import type { Draft } from 'immer';
import type { Doc, Id, MeshAtt } from '@pose2d/format/types';
import { mirrorName } from '@pose2d/format/doc/mirrorName';

/** The counterpart's id and record when `name` has a side suffix and a mesh of the paired name exists; else null. */
export function mirrorCounterpart(draft: Draft<Doc>, name: string): { id: Id; mesh: MeshAtt } | null {
  const pairName = mirrorName(name);
  if (pairName === null) return null;
  for (const [id, att] of Object.entries(draft.attachments)) {
    if (att.name === pairName && att.type === 'mesh') return { id, mesh: att };
  }
  return null;
}
